import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Copy, Title, Wrapper } from './styles';
function Header(props) {
    const { title, copy } = props;
    return (_jsxs(Wrapper, { children: [title && _jsx(Title, { children: title }), copy && _jsx(Copy, { children: copy })] }));
}
Header.defaultProps = {
    copy: null,
};
export default Header;
